import { DownOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react';
import { formatResource } from '../../common/helpers/localization/contentResourceHelper';
import commonResource from '../../locales/th/common.json';
import LazyImage from '../lazyImage/LazyImage';
import {
  AuthorAvatar,
  AuthorContent,
  AuthorDescription,
  AuthorInfo,
  AuthorName,
  AuthorWrapper,
  RightAuthorContent,
  ShowMoreButton,
} from './AboutAuthor.style';

interface AuthorProps {
  authorData: {
    total_post?: string;
    name: string;
    link: string;
    description: string;
  };
  authorImageProfile: {
    url: string;
  };
  shouldApplyLazyload: boolean;
}

function Author({
  authorData,
  authorImageProfile,
  shouldApplyLazyload,
}: AuthorProps): React.ReactElement {
  const descriptionRef = useRef(null);
  const [shouldDisplayShowMore, setShouldDisplayShowMore] = useState(true);
  const [isLineClampDisabled, setIsLineClampDisabled] = useState(false);

  useEffect(() => {
    const actualElement = descriptionRef?.current;
    if (actualElement) {
      setShouldDisplayShowMore(
        actualElement.scrollHeight !== actualElement.offsetHeight,
      );
    }
  }, []);

  const seeAllArticle = formatResource(commonResource.author.seeAllArticle, {
    total: authorData.total_post,
    author: authorData.name,
  });

  const onClickShowMore = () => {
    setShouldDisplayShowMore(false);
    setIsLineClampDisabled(true);
  };

  return (
    <AuthorWrapper data-test={'about-author'}>
      <AuthorContent>
        <AuthorAvatar>
          <LazyImage
            src={authorImageProfile.url}
            alt={authorData.name}
            lazyLoad={shouldApplyLazyload}
          />
        </AuthorAvatar>
        <RightAuthorContent>
          <AuthorInfo>
            <AuthorName>{authorData.name}</AuthorName>
            <a href={authorData.link}>{seeAllArticle}</a>
          </AuthorInfo>
          <AuthorDescription
            ref={descriptionRef}
            disableLineClamp={isLineClampDisabled}
          >
            {authorData.description}
          </AuthorDescription>
          {shouldDisplayShowMore && (
            <ShowMoreButton onClick={onClickShowMore}>
              {commonResource.showMore.More}
              <DownOutlined />
            </ShowMoreButton>
          )}
        </RightAuthorContent>
      </AuthorContent>
    </AuthorWrapper>
  );
}

export default Author;
